import { APPOINTMENTS_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

export const setSelectedId = id => ({
  type: types.SET_SELECTED_ID,
  payload: { id },
});

export const applicationIsReady = () => ({
  type: types.APPLICATION_IS_READY,
});

/**
 *
 * @param {string} id
 * @param {Object} params
 * @returns {import('modules/global/generic.types').Action<import('modules/global/generic.types').GetRequest<Object>>}
 */
export const fetchShareLink = (id, params) => ({
  type: types.FETCH_SHARE_LINK,
  payload: {
    request: {
      method: 'GET',
      url: `${APPOINTMENTS_API_URL}/${id}/link`,
      params,
    },
    id,
  },
});

export const fetchShareLinkSuccess = (id, shareLink) => ({
  type: types.FETCH_SHARE_LINK_SUCCESS,
  payload: {
    shareLink,
    id,
  },
});

export const openBookingModal = type => ({
  type: types.OPEN_BOOKING_MODAL,
  payload: {
    type,
  },
});

export const closeBookingModal = () => ({
  type: types.CLOSE_BOOKING_MODAL,
});

/** Read messages
 * @param {string} id: appointmentId
 * @param {object} meta
 * */
export const readMessages = (id, meta = {}) => ({
  type: types.READ_MESSAGES,
  payload: {
    id,
    request: {
      method: 'PATCH',
      url: `${APPOINTMENTS_API_URL}/${id}/messages/read`,
    },
  },
  meta,
});

export const readMessagesSuccess = id => ({
  type: types.READ_MESSAGES_SUCCESS,
  payload: { id },
});

export const fetchEvents = id => ({
  type: types.FETCH_EVENTS,
  payload: {
    request: {
      method: 'GET',
      url: `appointments/${id}/events`,
    },
    id,
  },
});

export const fetchEventsSuccess = (id, { content: events }, meta = {}) => ({
  type: types.FETCH_EVENTS_SUCCESS,
  payload: {
    id,
    events,
  },
  meta,
});

/**
 * @param {string} appointmentId
 * @returns {import('../types').FetchInterventionAction}
 */
export const fetchIntervention = appointmentId => ({
  type: types.FETCH_INTERVENTION,
  payload: {
    request: {
      method: 'GET',
      url: `appointments/${appointmentId}/intervention`,
      params: {
        projection: 'details',
      },
    },
    id: appointmentId,
  },
});

/**
 * @param {string} appointmentId
 * @param {import('modules/interventions/types/projections/detailed-intervention').DetailedIntervention} intervention
 * @returns {import('../types').FetchInterventionSuccessAction}
 */
export const fetchInterventionSuccess = (appointmentId, intervention) => ({
  type: types.FETCH_INTERVENTION_SUCCESS,
  payload: {
    id: appointmentId,
    intervention,
  },
});
